import { OnInit, Component, Input } from "@angular/core";
import { AdmissionWizardService } from "../../../services/wizard/admission/admission.wizzard.service";
import { MenuService } from "../../../services/menu.service";
import { FormGroup, FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MedicalOrderOperation } from "../../../model/medical-order-operation";
import { AdmissionService } from "../../../services/admission.service";
import { ConfirmDialogService } from "../../../services/confirm-dialog.service";
import { of } from "rxjs";
import { NotificationToastService } from "../../../services/notification-toast.service";

@Component({
  selector: "app-admission-operation-component",
  templateUrl: "./admission-operation.component.html",
  styleUrls: ["./admission-operation.component.css"],
})
export class AdmissionOperationComponent implements OnInit {
  form: FormGroup;
  returnurl: string;
  medicalApponitmentId: number;
  loading: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private confirmDialogService: ConfirmDialogService,
    private notificationToastService: NotificationToastService,
    private admissionService: AdmissionService,
    private menuService: MenuService
  ) {
    this.menuService.setMenuTitle("Admisión", "operaciones");
  }

  async finish() {
    try {
      this.loading = true;
      const existCombo = await this.admissionService.existsAdmissionInCombo(
        this.medicalApponitmentId
      );

      const admitirCombo = existCombo
        ? this.confirmDialogService
            .confirm(
              "Admisión",
              "Existen un turno para el mismo paciente y centro. ¿Desea recepcionarlo?",
              "Sí",
              "No"
            )
            .toPromise()
        : of(false).toPromise();

      await this.admissionService.setAdmissionFinished(
        this.medicalApponitmentId
      );

      if (await admitirCombo) {
        this.router.navigate([
          "admission-reception-wizard",
          this.medicalApponitmentId,
          true,
        ]);
      } else this.router.navigate([this.returnurl]);
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión"
      );
    } finally {
      this.loading = false;
    }
  }

  setMedicalOrderOperation(
    medicalOrderId: number,
    protocol: string,
    medicalAppointmentId: number
  ) {
    const medicalOrderOperation = new MedicalOrderOperation();
    medicalOrderOperation.MedicalOrderId = medicalOrderId;
    medicalOrderOperation.Protocol = protocol;
    medicalOrderOperation.MedicalApponitmentId = medicalAppointmentId;
    this.form = this.formBuilder.group({
      MedicalOrderOperation: [medicalOrderOperation],
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(async (params) => {
      const medicalOrderId = params["MedicalOrderId"];
      const protocol = params["Protocol"];
      const medicalApponitmentId = params["MedicalApponitmentId"];
      this.medicalApponitmentId = params["MedicalApponitmentId"];
      this.returnurl = params["return"];
      this.setMedicalOrderOperation(
        medicalOrderId,
        protocol,
        medicalApponitmentId
      );
    });
  }
}
